// extracted by mini-css-extract-plugin
module.exports = {"title":"UserDeals_title__2sauR","actions":"UserDeals_actions__f7Sv0","gift-photo":"UserDeals_gift-photo__1G_SB"};